import { formatNumber } from "helpers/system";
import React, { Fragment } from "react";
import { connect } from "react-redux";

const Show = ({ driverSalary, organization }) => {
    const rowSpan = driverSalary.details.length;

    return (
        <table className="table table-sm table-bordered">
            <thead>
                <tr>
                    <th>ФИО водителя</th>
                    <th>Данные расхода</th>
                    <th>Значение</th>
                    <th>Ставка</th>
                    <th>Сумма ({organization?.currencyData?.name}.)</th>
                </tr>
            </thead>
            <tbody>
                {driverSalary.details?.map((cell, index) => {
                    const { name, rate, value, amount, additionalData } = cell;

                    if (additionalData?.length) {
                        const { values, rates, amounts } = additionalData.reduce(
                            (acc, curr) => {
                                acc.values.push(`${curr.name}${curr.value ? ` (${curr.value})` : ""}`);
                                acc.rates.push(curr.rate);
                                acc.amounts.push(
                                    `${formatNumber(curr.amount, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                                );

                                return acc;
                            },
                            { values: [], rates: [], amounts: [] },
                        );

                        return (
                            <tr key={index}>
                                {index === 0 && <td rowSpan={rowSpan}>{driverSalary.driverName}</td>}
                                <td>{name}</td>
                                <td>
                                    {values.map((value, index) => (
                                        <Fragment key={index}>
                                            {index !== 0 && <br />}
                                            {value}
                                        </Fragment>
                                    ))}
                                </td>
                                <td>
                                    {rates.map((rate, index) => (
                                        <Fragment key={index}>
                                            {index !== 0 && <br />}
                                            {rate}
                                        </Fragment>
                                    ))}
                                </td>
                                <td>
                                    {amounts.map((amount, index) => (
                                        <Fragment key={index}>
                                            {index !== 0 && <br />}
                                            {amount}
                                        </Fragment>
                                    ))}
                                </td>
                            </tr>
                        );
                    }

                    return (
                        <tr key={index}>
                            {index === 0 && <td rowSpan={rowSpan}>{driverSalary.driverName}</td>}
                            <td>{name}</td>
                            <td>{value}</td>
                            <td>{rate}</td>
                            <td>{formatNumber(amount, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        </tr>
                    );
                })}
                <tr>
                    <td colSpan={4}>
                        <b>Итого</b>
                    </td>
                    <td>
                        <b>
                            {formatNumber(driverSalary.totalSalary, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </b>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const container = (Component) => {
    const mapState = (state) => ({
        organization: state.profile.organization,
    });

    const mapDispatch = (_dispatch) => ({});

    return connect(mapState, mapDispatch)(Component);
};

export default container(Show);
